// extracted by mini-css-extract-plugin
export default {"section":"AccountList_section__STMR6","header":"AccountList_header__9ivSV"};